


import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, getDocs, addDoc, doc, updateDoc } from "firebase/firestore";
import { getStorage } from "firebase/storage";



const firebaseConfig = {
  apiKey: "AIzaSyDtSSfXYZdq-DdDGRRgE7GOYADD58G1zXE",
  authDomain: "adil-eye-vision-center.firebaseapp.com",
  projectId: "adil-eye-vision-center",
  storageBucket: "adil-eye-vision-center.firebasestorage.app",
  messagingSenderId: "630104375195",
  appId: "1:630104375195:web:56bbfff040c6885450ab3e"
};


const app = initializeApp(firebaseConfig);

const db = getFirestore(app);  // Firestore initialization
const storage = getStorage(app);  // Firebase Storage initialization

export const auth = getAuth(app);
export { db, storage, getDocs, collection, addDoc, doc, updateDoc  };  // Correct export